import React, { FunctionComponent } from "react";
import { Aside, ButtonProps, CommandBarButton, useDisclosure } from "sprint-common-web";

import { WatermarkRuleForm } from "../../forms/WatermarkRuleForm";

export type CreateWatermarkRuleButtonProps = ButtonProps;

export const CreateWatermarkRuleButton: FunctionComponent<CreateWatermarkRuleButtonProps> = ({
    disabled
}: CreateWatermarkRuleButtonProps) => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <>
            <CommandBarButton onClick={onOpen} text="Add" icon="Add" disabled={disabled} />
            <Aside isOpen={isOpen} type="form" headerText={"Add Watermark Rule"} onDismiss={onClose}>
                <WatermarkRuleForm onCancel={onClose} onSubmit={onClose} />
            </Aside>
        </>
    );
};
